import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';
import Utils from "../Common/Utils.js";

const DeleteDevicePopup = (props) => {
  const { classes } = props;

  const cleanReminder = () => {
    let find;

    find = props.checkedReminderList.findIndex(reminder => reminder.alert_type === props.reminderToDelete)
    if (find !== undefined && find !== -1) {
      let new_reminder_list = props.checkedReminderList;
      new_reminder_list.splice(find, 1)
      props.setCheckedReminderList(new_reminder_list)
      props.setCheckedReminder(false)
    }
  }

  const checkDelete = () => {
    let to_hide = false
    if (props.deleteDeviceID === props.selectedDeviceList.device1.id) {
      props.selectedDeviceList.device1.id_old = props.selectedDeviceList.device1.id
      props.selectedDeviceList.device1.id = "dissociate"
      props.selectedDeviceList.device1.nickname = "--"
      props.selectedDeviceList.device1.sn = ""
      to_hide = "devices"
    }
    else if (props.deleteDeviceID === props.selectedDeviceList.device2.id) {
      props.selectedDeviceList.device2.id_old = props.selectedDeviceList.device2.id
      props.selectedDeviceList.device2.id = "dissociate"
      props.selectedDeviceList.device2.nickname = "--"
      props.selectedDeviceList.device2.sn = ""
      to_hide = "devices"
    }
    else if (props.deleteDeviceID === props.selectedDeviceList.device3.id) {
      props.selectedDeviceList.device3.id_old = props.selectedDeviceList.device3.id
      props.selectedDeviceList.device3.id = "dissociate"
      props.selectedDeviceList.device3.nickname = "--"
      props.selectedDeviceList.device3.sn = ""
      to_hide = "devices"
    }
    else if (props.deleteDeviceID === props.selectedDeviceList.device4.id) {
      props.selectedDeviceList.device4.id_old = props.selectedDeviceList.device4.id
      props.selectedDeviceList.device4.id = "dissociate"
      props.selectedDeviceList.device4.nickname = "--"
      props.selectedDeviceList.device4.sn = ""
      to_hide = "devices"
    }    
    else if (props.deleteDeviceID === ("tucky_smartphone")) {
      let new_module_activation = props.moduleActivation
      let module_activation_index = new_module_activation.findIndex((m) => m.name === "tucky_smartphone")
      if (module_activation_index !== -1) {
        new_module_activation[module_activation_index].used = false
      }
      props.setModuleActivation(new_module_activation)
      to_hide = "smartphone"
    }
    else if (props.deleteDeviceID.includes("healthform_")) {
      let new_module_activation = props.moduleActivation
      let module_activation_index = new_module_activation.findIndex((m) => m.name.toUpperCase() === props.deleteDeviceID.split('_')[1].toUpperCase())
      if (module_activation_index !== -1) {
        new_module_activation[module_activation_index].used = false
      }
      props.setModuleActivation(new_module_activation)
      to_hide = "healthforms"
    }
    else if (props.deleteDeviceID === "pain") {
      let new_module_activation = props.moduleActivation
      let module_activation_index = new_module_activation.findIndex((m) => m.name === props.deleteDeviceID)
      if (module_activation_index !== -1) {
        new_module_activation[module_activation_index].used = false
        let new_painAlert = props.painAlert
        new_painAlert.activated = false
        props.setPainAlert(new_painAlert)
        props.setCheckedPain(false)
      }
      props.setModuleActivation(new_module_activation)
      to_hide = "healthforms"
    }
    else if (props.deleteDeviceID === "niv" || props.deleteDeviceID === "oxigen_therapy") {
      let new_module_activation = props.moduleActivation
      let module_activation_index = new_module_activation.findIndex((m) => m.name === props.deleteDeviceID)
      if (module_activation_index !== -1) {
        new_module_activation[module_activation_index].used = false
        let new_breathingAlert = props.breathingAlert
        new_breathingAlert.activated = false
        props.setBreathingAlert(new_breathingAlert)
        props.setCheckedBreathing(false)
        let new_breathingOxygenRateAlert = props.breathingOxygenRateAlert
        new_breathingOxygenRateAlert.activated = false
        props.setBreathingOxygenRateAlert(new_breathingOxygenRateAlert)
        props.setCheckedBreathingOxygenRate(false)
      }
      props.setModuleActivation(new_module_activation)
      to_hide = "modules"
    }
    if (to_hide === "devices") {
      if (!Utils.testIsAnyDeviceAssociate(props.selectedDeviceList)) {
        props.selectedDeviceList.gateway.id = "dissociate"
      }
    }
    props.setChangeOngoing(true)
    props.setDeleteDeviceID("")
    props.cleanModulesDisplays(to_hide)
    cleanReminder()
    props.setDisplayDeleteDevicePopup(!props.displayDeleteDevicePopup)
  }

  let deleted_device;

  if (props.deleteDeviceID.includes("healthform_") || props.deleteDeviceID === "pain" || props.deleteDeviceID === "niv" || props.deleteDeviceID === "oxigen_therapy") {
    deleted_device = {sn: props.deleteDeviceID}
  }
  else if (props.deleteDeviceID === "tucky_smartphone") {
    deleted_device = {sn: "Smartphone Tucky"}
  }
  else {
  deleted_device = props.device_list.find(device => device.id_device === props.deleteDeviceID)
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
	        <div className="form-group" style={{paddingTop:"5%"}}>
            <FormattedMessage id="device.deleteVerification" defaultMessage="Are you sure you want to dissociate this device?" values={{ID: deleted_device.sn}} />
	        </div>
          <div style={{ display: "flex", justifyContent: "center", gap: "1em", marginTop: "0.5em" }}>
            <button onClick={props.cancelPopup} className="btn btn-danger">
              <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
            </button>
            <button onClick={checkDelete} className="btn btn-success">
              <FormattedMessage id="button.submit" defaultMessage="Submit" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(Constants.styles)(DeleteDevicePopup);